/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When form was started
 * @export
 * @interface StartedAt1
 */
export interface StartedAt1 {
}

/**
 * Check if a given object implements the StartedAt1 interface.
 */
export function instanceOfStartedAt1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartedAt1FromJSON(json: any): StartedAt1 {
    return StartedAt1FromJSONTyped(json, false);
}

export function StartedAt1FromJSONTyped(json: any, ignoreDiscriminator: boolean): StartedAt1 {
    return json;
}

export function StartedAt1ToJSON(value?: StartedAt1 | null): any {
    return value;
}

